import React from 'react';
import Icon from '../../../components/AppIcon';

const QuickStatsPanel = ({ stats }) => {
  return (
    <div className="quick-stats-panel grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4 lg:gap-6">
      <div className="bg-card border border-primary/50 rounded-sm p-3 md:p-4 lg:p-5 shadow-glow-cyan-sm hover:shadow-glow-cyan-md transition-all duration-base">
        <div className="flex items-center gap-2 mb-2">
          <Icon name="Zap" size={18} color="var(--color-primary)" />
          <span className="text-xs md:text-sm font-caption text-muted-foreground">
            WINS
          </span>
        </div>
        <p className="text-xl md:text-2xl lg:text-3xl font-data text-primary">
          {stats?.totalWins}
        </p>
      </div>
      <div className="bg-card border border-error/50 rounded-sm p-3 md:p-4 lg:p-5 shadow-glow-magenta-sm hover:shadow-glow-magenta-md transition-all duration-base">
        <div className="flex items-center gap-2 mb-2">
          <Icon name="X" size={18} color="var(--color-error)" />
          <span className="text-xs md:text-sm font-caption text-muted-foreground">
            LOSSES
          </span>
        </div>
        <p className="text-xl md:text-2xl lg:text-3xl font-data text-error">
          {stats?.totalLosses}
        </p>
      </div>
      <div className="bg-card border border-accent/50 rounded-sm p-3 md:p-4 lg:p-5 shadow-glow-green-sm hover:shadow-glow-green-md transition-all duration-base">
        <div className="flex items-center gap-2 mb-2">
          <Icon name="TrendingUp" size={18} color="var(--color-accent)" />
          <span className="text-xs md:text-sm font-caption text-muted-foreground">
            AVG SCORE
          </span>
        </div>
        <p className="text-xl md:text-2xl lg:text-3xl font-data text-accent">
          {stats?.averageScore}
        </p>
      </div>
      <div className="bg-card border border-warning/50 rounded-sm p-3 md:p-4 lg:p-5 shadow-glow-cyan-sm hover:shadow-glow-cyan-md transition-all duration-base">
        <div className="flex items-center gap-2 mb-2">
          <Icon name="Clock" size={18} color="var(--color-warning)" />
          <span className="text-xs md:text-sm font-caption text-muted-foreground">
            PLAYTIME
          </span>
        </div>
        <p className="text-xl md:text-2xl lg:text-3xl font-data text-warning">
          {stats?.totalPlaytime}h
        </p>
      </div>
    </div>
  );
};

export default QuickStatsPanel;